const t = "Договори", a = "Контрагенти", c = { contracts: t, counterparties: a };
export {
  t as contracts,
  a as counterparties,
  c as default
};
//# sourceMappingURL=navigation.json.js.map
